import { Stack } from '@pypestream/design-system';
import { FC } from 'react';

import { Loader } from '../loader';

/** Keeps the body from collapsing (and the rows from jumping in) while loading. */
const MIN_HEIGHT = 240;

/**
 * The shared "still fetching" panel for the Project Settings sections and
 * Default Messages.
 *
 * Those pages are mounted BEFORE their data is requested — `WithLoadingState` /
 * `ProjectSettings` only gate on the app-level machine state, and each section
 * fires its own `load*` event from an effect once the machine is idle. Until
 * that resolves the body rendered its loaded-and-empty shape: a `DataTable` with
 * nothing but a header row, an empty card list, or a form of blank inputs. On a
 * solution with many pypes/channels that read is slow enough to read as "there
 * is nothing here" — or, on Advanced Settings, as invalid input.
 *
 * Only the BODY is replaced: the section header keeps the env switcher and the
 * primary action in place, so the screen doesn't reflow when the data lands.
 *
 * Callers gate this on the same `hasLoaded` flag as `SettingsEmptyState`, and
 * MUST render it at that flag's position in the tree — inside the wrapper that
 * shields the portaled modals (see portaled-modal-sibling.test.tsx).
 */
export const SettingsSectionLoader: FC<{ testId?: string }> = ({ testId }) => (
  <Stack
    test-id={testId}
    alignItems="center"
    justifyContent="center"
    style={{ minHeight: MIN_HEIGHT }}
  >
    <Loader relative />
  </Stack>
);
